module.exports = __webpack_public_path__ + "img/phon4.d49cea99.png";